<template>
    <div v-if="activeView === 'info'" id="info-content" class="row">
        <div class="col-12 pt-2">
            <p
                class="lead fw-bold"
                v-html="dto.infoContent.title"
            />
        </div>
        <div class="col-12 pt-2">
            <p
                class="standard"
                v-html="dto.infoContent.text"
            />
            <AlertMessage
                class="ob1-alert"
                :title="dto.infoContent.info"
                type="info"
                with-alert-role
            />
        </div>
    </div>
</template>

<script lang="ts">
import {PropType} from "vue";
import {InternetDiscountPopinDto} from "../../cart/models/InternetDiscountPopinDto";
import AlertMessage from "../ob1/AlertMessage.vue";

export default {
    name: "DiscountPopinInfoShared",
    components: {
        AlertMessage
    },
    props: {
        activeView: {
            type: String,
            required: true
        },
        dto: {
            type: Object as PropType<InternetDiscountPopinDto>,
            required: true
        }
    }
}
</script>
